module.exports = __webpack_public_path__ + "img/madera027.25cb96d5.jpg";